module.exports = __webpack_public_path__ + "static/annual-report-2016-17-2e0197e091bc621b14ce385719df0235.pdf";